// AP-076 F3.1 · Heartbeat automático do Portal do Funcionário (60s).
// Envia para POST /api/employee-portal/monitoring/heartbeat usando o
// employeeApi (autenticado pelo employee token). Zero impacto na auth.
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { employeeApi } from "../context/EmployeeAuthContext";

const HEARTBEAT_MS = 60000;

export function useEmployeeHeartbeat(employeeId) {
  const location = useLocation();
  const timerRef = useRef(null);
  const pathRef = useRef(location.pathname);
  useEffect(() => { pathRef.current = location.pathname; }, [location.pathname]);

  useEffect(() => {
    if (!employeeId) return;
    const ping = async (action = "page_view") => {
      try { await employeeApi.post("/employee-portal/monitoring/heartbeat", { path: pathRef.current, action }); } catch {}
    };
    ping();
    timerRef.current = setInterval(() => ping(), HEARTBEAT_MS);
    return () => { if (timerRef.current) clearInterval(timerRef.current); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [employeeId, location.pathname]);
}
